import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { EnvironmentService } from '../services/environment.service';

/**
 * Classe utilitaire pour la gestion des alias Trustbuilder.
 * Fournit des méthodes statiques pour générer et extraire des alias utilisateur.
 */
@Injectable({
  providedIn: 'root',
})
export class TrustbuilderUtils {

  constructor(private environmentService : EnvironmentService) {}
  /**
   * Génère un alias à partir d'un nom d'utilisateur.
   * @param username Le nom d'utilisateur d'origine.
   * @returns L'alias généré ou null si le nom d'utilisateur est vide.
   */
  aliasOf(username: string): string {
    if (username) {
      return this.environmentService.get().issuer + '-' + this.environmentService.get().companySiteIdentifier + '-' + username;
    }
    return null;
  }

  /**
   * Extrait le nom d'utilisateur d'un alias.
   * @param alias L'alias complet.
   * @returns Le nom d'utilisateur extrait ou null si l'alias est vide.
   */
  usernameOf(alias: string): string {
    if (alias) {
      return alias.replace(this.environmentService.get().issuer + '-', '').replace(this.environmentService.get().companySiteIdentifier + '-', '');
    }
    return null;
  }
}
